import { useState } from "react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Account() {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await http.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password aggiornata");
      setCur("");
      setNext("");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="fade-up max-w-md space-y-6">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-blue-600">Sicurezza</p>
        <h1 className="mt-1 font-heading text-3xl font-bold tracking-tight text-slate-900">Account</h1>
        <p className="mt-1 text-sm text-slate-500">{user.email}</p>
      </div>
      <form onSubmit={submit} className="space-y-4 rounded-xl border border-slate-200 bg-white p-6">
        <div className="space-y-1.5"><Label htmlFor="cur">Password attuale</Label><Input id="cur" type="password" required value={cur} onChange={(e) => setCur(e.target.value)} data-testid="account-current-password-input" /></div>
        <div className="space-y-1.5"><Label htmlFor="new">Nuova password (min. 8 caratteri)</Label><Input id="new" type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} data-testid="account-new-password-input" /></div>
        <button type="submit" data-testid="account-save-password-button" className="rounded-md bg-slate-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-blue-600">Cambia password</button>
      </form>
    </div>
  );
}
